// extracted by mini-css-extract-plugin
module.exports = {"crumb":"Breadcrumbs_crumb__TGOar","next":"Breadcrumbs_next__dkFyu","white":"Breadcrumbs_white__Tlp_B"};